// This file should be removed w/ React v15 upgrade / legacy React removal.
window.CORE_BUNDLE_LOADED = true;
